import { render, staticRenderFns } from "./RecordLog.vue?vue&type=template&id=66de70c6&scoped=true&"
import script from "./RecordLog.vue?vue&type=script&lang=js&"
export * from "./RecordLog.vue?vue&type=script&lang=js&"
import style0 from "./RecordLog.vue?vue&type=style&index=0&id=66de70c6&lang=scss&scoped=true&"
import style1 from "./RecordLog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de70c6",
  null
  
)

export default component.exports